import React, { SVGProps } from 'react'

const SmallForwardIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill="#fff"
      d="m6.654 4.377 1.325-1.325L16.93 12l-8.95 8.95-1.325-1.326L14.276 12 6.654 4.377Z"
    />
  </svg>
)
export default SmallForwardIcon
